module.exports = __webpack_public_path__ + "static/img/about_h5bg_01_zh.442a7ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_01_zh.png
// module id = libN
// module chunks = 34